import { useEffect } from "react"
import { X } from "lucide-react"

interface SignInErrorToastProps {
  /** Clear the error — fired by the 4s auto-dismiss and when the toast unmounts. */
  onDismiss: () => void
}

const AUTO_DISMISS_MS = 4000

/**
 * "Can't log in" toast shown on top of the sign-in screen when Apple/Google
 * sign-in fails. Overlays the header (positioned by the caller) and
 * auto-dismisses after 4s. Styles are 1:1 from the Figma "Log In - Error Toast"
 * state: peach border + glow on the dark surface.
 */
export function SignInErrorToast({ onDismiss }: SignInErrorToastProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, AUTO_DISMISS_MS)
    return () => clearTimeout(timer)
  }, [onDismiss])

  return (
    <div
      data-slot="sign-in-error-toast"
      role="alert"
      className="flex items-center gap-3 rounded-[16px] border-2 border-peach bg-dark-surface p-3 shadow-[0_0_10px_var(--peach)]"
    >
      <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-peach/20">
        <X className="size-6 text-peach" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <p className="text-base font-semibold text-peach">Can’t log in</p>
        <p className="truncate text-xs text-purple-light/70">
          Please try again or use another method
        </p>
      </div>
    </div>
  )
}
